module.exports = __webpack_public_path__ + "img/login_top1.64896100.png";